import 'jquery-validation';
import fetcher from 'shop-packages/redux/checkout/fetcher';
import { ApiClient } from 'shop-packages';

class CraftGateOption {
  constructor({pk}) {
    this.form = document.getElementById('CrafGateForm');
    this.submitButton = this.form?.querySelector('#CraftGateCompleteButton');
    this.loading = this.form?.querySelector('.js-craftgate-loading');
    this.iframeContainer = this.form?.querySelector('.js-craftgate-iframe-container');
    this.content = this.form?.querySelector('.js-craftgate-content');
    this.formError = this.form?.querySelector('.js-craftgate-iframe-error');
    this.agreementError = this.form?.querySelector('.js-crafgate-error-aggreement');
    this.agreementInput = this.form?.querySelector('.js-checkout-agreement-input');
    this.paymentPk = pk;
    this.init();
  }

  handleLoadingIndicator = (event) => {
    const { type, value } = event.data;
    if (type === 'WAITING_FOR_RESPONSE_FROM_SERVER') {
        this.loading?.toggleAttribute('hidden', !value);
    }
  };

  
  handleSubmitButtonState = (event) => {
    const { type, value } = event.data;
    if (type === 'SUBMIT_BUTTON_ENABLED') {
      this.submitButton.disabled = !value;
    }
  };
  
  adjustIframeHeight = (event) => {
    const { type, value } = event.data;
    if (type === 'HEIGHT_CHANGED') {
      const iframe = document.getElementById('cg-iframe');
      if (iframe) {
        iframe.style.height = value + 'px';
      }
    }
  };

  bindEvents = () => {
    window.addEventListener('message', this.adjustIframeHeight);
    window.addEventListener('message',this.handleLoadingIndicator);
    window.addEventListener('message',this.handleSubmitButtonState);
    this.agreementInput.addEventListener('input', this.handleAgreementValidation);
    this.form.addEventListener('submit',this.onSubmit)
  }

  handleAgreementValidation = () => this.agreementError.toggleAttribute('hidden', this.agreementInput.checked);

  onSubmit = (e) => {
    e.preventDefault();

    if (!this.agreementInput.checked) {
      this.agreementError.removeAttribute('hidden');
      return;
    }

    const iframeWin = document.getElementById("cg-iframe")?.contentWindow;

    iframeWin?.postMessage({
      type: 'CRAFTGATE_SUBMIT_FORM'
      }, '*')
  }

    initializeLoadingState = () => {
      this.onPendingUpdate(true);
      this.iframeContainer.innerHTML = '';
      this.submitButton && (this.submitButton.disabled = true);
      this.loading?.removeAttribute('hidden');
      this.content?.setAttribute('hidden', true);
    }


   init = async () => {
    this.initializeLoadingState();

    this.paymentPk && await fetcher(ApiClient.checkout.setPaymentOption(this.paymentPk));

    const url = `${window.location.href}?${new URLSearchParams({ page: 'RedirectionPaymentSelectedPage' })}`;

    const csrf = document.cookie
      .split('; ')
      .find(row => row.startsWith('csrftoken='))
      .split('=')[1];

    const body = new URLSearchParams({ agreement: true });

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRFToken': csrf,
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body
    });

    if (!response.ok) {
      this.handleIframeLoadFailure();
      return;
    }

    const data = await response.json();
    const errors = data?.errors;
    const redirectUrl = data?.context_list?.[0]?.page_context?.redirect_url;

    if (errors || !redirectUrl) {
      this.handleIframeLoadFailure();
      return;
    }

    if (redirectUrl && this.iframeContainer) {
      const urlObj = new URL(redirectUrl);
      const urlSearchParams = new URLSearchParams(urlObj.search);
      urlSearchParams.append('t', new Date().getTime());

      const iframeAttributes = {
        id: 'cg-iframe',
        className: 'js-craftgate-iframe',
        src: `${urlObj.origin}${urlObj.pathname}?${urlSearchParams.toString()}`,
        width: '100%',
        height: '600',
        frameBorder: '0',
        sandbox: 'allow-top-navigation allow-scripts allow-same-origin allow-forms',
        name: Date.now()
      };
    
      const iframe = Object.assign(document.createElement('iframe'), iframeAttributes);

      this.iframeContainer.appendChild(iframe);
      this.bindEvents();
    }

    this.loading?.setAttribute('hidden', true);
    this.content?.removeAttribute('hidden');
  }

  showError(error) {
    this.formError.innerHTML = error;
    this.formError.removeAttribute('hidden');
  }

  handleIframeLoadFailure(message = 'Bir sorun oluştu, lütfen tekrar deneyin.') {
    this.iframeContainer.innerHTML = '';
    this.showError(message);
    this.onPendingUpdate(false);
    this.loading?.setAttribute('hidden', true);
    this.content?.setAttribute('hidden', true);
  }

  onPendingUpdate(isPending) {
    if (!this.submitButton) {
      return;
    }

    this.submitButton.toggleAttribute('disabled', !isPending);
  }

  unmount() {
    window.removeEventListener('message', this.adjustIframeHeight);
    window.removeEventListener('message',this.handleLoadingIndicator);
    window.removeEventListener('message',this.handleSubmitButtonState);
    this.agreementInput.removeEventListener('input', this.handleAgreementValidation);
    this.form.removeEventListener('submit',this.onSubmit);
  }
}

export default CraftGateOption;